
import axios from "axios";
import CommonApi from "./CommonApi";

export default class ToDoApi {

    static getBaseUrl() {
        return CommonApi.getHost().replace(/\/$/, "");
    }
    static getBaseUrlForFoto() {
        return process.env.REACT_APP_PRODUCTION_HOST.replace(/\/$/, "");
    }

    static checkResponse(response) {
        const data = response.data;

        if (data?.Status === false) {
            throw new Error(
                data.Error ||
                data.error ||
                "ToDo API error"
            );
        }

        return data;
    }

    static createFormData(fields = {}, photos = []) {
        const data = new FormData();

        Object.entries(fields).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                data.append(key, String(value));
            }
        });

        photos.forEach((item, index) => {
            const file = item?.blob ?? item;

            if (!(file instanceof Blob)) {
                throw new Error("Photo must be a Blob or File");
            }

            const extensions = {
                "image/jpeg": "jpg",
                "image/png": "png",
                "image/webp": "webp"
            };

            const ext = extensions[file.type] || "jpg";

            const filename = file instanceof File
                ? file.name
                : `photo-${index + 1}.${ext}`;

            data.append("photos", file, filename);
        });

        return data;
    }

    static async getTasks(
        house = "",
        floor = "",
        status = "all",
        signal
    ) {
        console.log(house, floor, status)
        const response = await axios.get(
            `${this.getBaseUrl()}/ToDo/getTasks`,
            {
                params: {
                    house : house,
                    floor  : floor,
                    status
                },
                signal
            }
        );

        return this.checkResponse(response);
    }


    static async addTask(task, photos = []) {
        const data = this.createFormData(
            {
                house: task.house,
                floor: task.floor,
                comment: task.comment,
                author: task.author,
                date: task.date
            },
            photos
        );

        const response = await axios.post(
            `${this.getBaseUrl()}/ToDo/addTask`,
            data
        );

        return this.checkResponse(response);
    }


    static async addPhotos(id, photos = []) {
        const data = this.createFormData({}, photos);

        const response = await axios.post(
            `${this.getBaseUrl()}/ToDo/addPhotos/${encodeURIComponent(id)}`,
            data
        );

        return this.checkResponse(response);
    }

    static async completeTask(
        id,
        photos = [],
        completionComment = ""
    ) {
        const data = this.createFormData(
            { completionComment },
            photos
        );

        const response = await axios.patch(
            `${this.getBaseUrl()}/ToDo/completeTask/${encodeURIComponent(id)}`,
            data
        );

        return this.checkResponse(response);
    }

    static async reopenTask(id) {
        const response = await axios.patch(
            `${this.getBaseUrl()}/ToDo/reopenTask/${encodeURIComponent(id)}`
        );

        return this.checkResponse(response);
    }

    static async deleteTask(id) {
        const response = await axios.delete(
            `${this.getBaseUrl()}/ToDo/deleteTask/${encodeURIComponent(id)}`
        );

        return this.checkResponse(response);
    }

    static getPhotoUrl(photo) {
        const url = typeof photo === "string"
            ? photo
            : photo?.url;

        if (!url) return "";

        return new URL(
            url,
            `${this.getBaseUrlForFoto()}/`
        ).href;
    }
}
